export default "__VITE_ASSET__BEdpdc37__"